import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  alternativeOffersCphOsl,
  orderEligibilitiesMockEligibleToRefundWithUnOneWay,
  orderWithOneStop,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const disruptedOnewayOneStopMock: MockMap = {
  retrieveOrder: [createMockData(orderWithOneStop, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundWithUnOneWay, [], [orderNotEligibleForRefundWarning])],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl)]
};
